import { sdk } from '../../config'
import { CreateOneTimeReminderRequest } from '../../sdk'
import { api } from '.'
const createOneTimeReminder = sdk.createOneTimeReminder.bind(sdk)

// This api slice is for reminder related APIs
const reminderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createOneTimeReminder: builder.mutation<
      string,
      CreateOneTimeReminderRequest
    >({
      query: (req) => () => createOneTimeReminder(req),
      invalidatesTags: [{ type: 'Reminder' }]
    })
  }),

  overrideExisting: true
})

export const { useCreateOneTimeReminderMutation } = reminderApi
